import { Component, OnInit,ViewChild } from '@angular/core';
import { RoutingService } from '../../services/routing.service';
import { RestapiService } from '../../services/restapi.service';
import { Subscription } from 'rxjs';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-search',
  templateUrl: './app-search.component.html',
  styleUrls: ['./app-search.component.scss']
})
export class AppSearchComponent implements OnInit {
  searched: any;
  search: any;
  ready: boolean = false;
  @ViewChild('content') content;
  constructor(
    public route: RoutingService,
    public api: RestapiService,
    private modalService: NgbModal
  ) { }

  ngOnInit(): void {
  }

  searchGlobal(s) {
    this.searched = [];
    this.ready = false;
    this.api.getdata('websection', {
      per_page: 100,
      filters: {
        title: { value: s, operator: 'like' }
      }
    }).subscribe(res => {
      console.log('resultados websection busqueda', res)
      if (res.status == true) {
        res.result.data.forEach(el => {
          el.title = el.title.es;
          this.searched.push(el)
        });
        console.log('resultados busqueda', this.searched);
        this.ready = true;
      }
    });

    this.api.getdata('webresource', {
      per_page: 100,
      filters: {
        title: { value: s, operator: 'like' }
      }
    }).subscribe(res => {
      console.log('resultados webresource busqueda', res)
      if (res.status == true) {
        res.result.data.forEach(el => {
          el.title = el.title.es;
          this.searched.push(el)
        });
        console.log('resultados busqueda', this.searched);
        this.ready = true;
      }
    })


    this.api.getdata('webschedule', {
      per_page: 100,
      filters: {
        title: { value: s, operator: 'like' }
      }
    }).subscribe(res => {
      console.log('resultados webschedule busqueda', res)
      if (res.status == true) {
        res.result.data.forEach(el => {
          el.title = el.title.es;
          this.searched.push(el)
        });
        console.log('resultados busqueda', this.searched);
        this.ready = true;
      }
    })
  }

  openSearch() {
    //console.log('selected')
    this.modalService.open(this.content, { windowClass: "app-search" });
  }

  getParentUrl(id){
    /* let url = '';
    this.routes.forEach(r => {
      if(r.id == id){
        url=r.url;
      }
    }); */
  }

}
